import { render, staticRenderFns } from "./StatusBilhete.vue?vue&type=template&id=2adf0596&scoped=true"
import script from "./StatusBilhete.vue?vue&type=script&lang=js"
export * from "./StatusBilhete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adf0596",
  null
  
)

export default component.exports